import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { normalizeLanguage, SupportedLanguage } from '../../utils/language.util';

interface UserData {
  id: string;
  title: string;
  firstName: string;
  lastName: string;
  events: Events
}
interface Events {
  confirmedTermsOfUse: string | null;
  lastLogin: string | null;
  firstLogin: string | null;
  confirmBankConsent: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  userDetails: any;
  private userData = new BehaviorSubject<UserData>({
    id: '',
    title: '',
    firstName: '',
    lastName: '',
    events: {
      confirmedTermsOfUse: '',
      lastLogin: '',
      firstLogin: '',
      confirmBankConsent: ''
    },
  });
  private fundAdminCockpitUrl = new BehaviorSubject('');
  private selectedVehicle = new BehaviorSubject('');
  private resetValues = new BehaviorSubject('');
  private isMainUserSubject = new BehaviorSubject<boolean>(false); // Default value

  userDataObservable$ = this.userData.asObservable();
  fundAdminCockpitUrlObservable$ = this.fundAdminCockpitUrl.asObservable();
  selectedVehicleObservable$ = this.selectedVehicle.asObservable();
  resetValuesObservable$ = this.resetValues.asObservable();
  isMainUser$ = this.isMainUserSubject.asObservable();

  public setResetValues(data: string) {
    this.resetValues.next(data);
  }

  public setFundAdminCockpitUrl(data: string) {
    this.fundAdminCockpitUrl.next(data);
  }

  public setSelectedVehicle(data: any) {
    this.selectedVehicle.next(data);
  }

  public setUserData(data: any) {
    if (data) {
      this.userData.next(data);
    }
  }

  setUserConfig(name: any, interfaceLanguage: any, userId: any) {
    if (name && userId && interfaceLanguage) {
      localStorage.setItem(
        'user',
        JSON.stringify({
          name: name,
          languageCode: interfaceLanguage,
          id: userId,
        })
      );
    }
    if (!localStorage.getItem('user')) {
      localStorage.setItem(
        'user',
        JSON.stringify({
          name: 'Wendelin Luther',
          languageCode: 'en',
          id: 1,
        })
      );
    }

    this.userDetails = localStorage.getItem('user');
  }

  getUserConfig() {
    if (!this.userDetails && typeof localStorage !== 'undefined') {
      this.userDetails = localStorage.getItem('user');
    }
    return this.userDetails;
  }

  getUserConfigObject(): {
    name?: string;
    languageCode?: string;
    id?: string | number;
  } {
    try {
      return JSON.parse(this.getUserConfig() || '{}');
    } catch {
      return {};
    }
  }

  getStoredLanguage(): SupportedLanguage {
    return normalizeLanguage(this.getUserConfigObject().languageCode);
  }

  setIsMainUser(isMainUser: boolean): void {
    this.isMainUserSubject.next(isMainUser);
  }
}
